import axios from 'axios';
import { getCookieByName } from '../utils/cookies';

import {
  LEGAL_DOCUMENTS_INTERESTED_PARTIES_ENDPOINT,
  LEGAL_DOCUMENTS_ENDPOINT
} from '../consts'


const get_endpoint_with_language = (endpoint) => {
  const language = getCookieByName('django_language')
  return `/${language}${endpoint}`
}

export const isUserInterestedParties = ({
  propertyId,
  entityId,
  onResponse = () => { },
  onError = () => { },
}) => {
  axios.get(get_endpoint_with_language(LEGAL_DOCUMENTS_INTERESTED_PARTIES_ENDPOINT), {
    params: {
      property_id: propertyId,
      entity_id: entityId,
    }
  })
    .then(onResponse)
    .catch(onError);
}

export const getLegalDocuments = ({
  propertyId,
  entityId,
  subscriberCountryId,
  onResponse = () => { },
  onError = () => { },
}) => {
  axios.get(get_endpoint_with_language(LEGAL_DOCUMENTS_ENDPOINT), {
    params: {
      property_id: propertyId,
      entity_id: entityId,
      subscriber_country_id: subscriberCountryId,
    }
  })
    .then(onResponse)
    .catch(onError);
}
